/**
 * This cookie function is derived from lib/jquery-ui/js/jquery.cookie.js
 *
 * It is not anticipated to be used in new codes, but perhaps it will be.
 *
 * Note that the original cookie function was intended for use both as a reader and a writer, but
 * (a) this makes the using programmer's intent harder to determine;
 * (b) it makes the implementation harder to read
 * (c) it was not necessary for implementing the code i was working on.
 *
 * If you discover a usage of $.cookie(a) i.e. which is functioning as a getter,
 * do feel free to consult the original function but please implement it separately.
 */

type CookieOptions = {
	expires?: number|Date
	path?: string
	domain?: string
	secure?: boolean
}

const defineCookieExpiryString = (expires: number): string => {
	if (!expires) {
		return ''
	}

	const date = new Date()
	date.setTime(date.getTime() + (expires * 24 * 60 * 60 * 1000))
	
	return '; expires=' + date.toUTCString()
}

export const setCookie = (name: string, value: string, path: string, expiry: number): void => {
	if (value === null) {
		value = ''
		expiry = -1
	}

	const pathStr = path && ('; path=' + path)
	const secureStr = '; secure'
	document.cookie = `${name}=${encodeURIComponent(value)}${defineCookieExpiryString(expiry)}${pathStr}${secureStr}`
}

// this has been migrated across from analytics_html.php to maintain backwards compatibility.
export const Get_Cookie = (name: string) => {
	const start = document.cookie.indexOf( name + "=" );
	const len = start + name.length + 1;
	if ( ( !start ) && ( name != document.cookie.substring( 0, name.length ) ) )
	{
		return null;
	}
	if ( start == -1 ) return null;

	let end = document.cookie.indexOf( ";", len );
	if ( end == -1 ) end = document.cookie.length;

	return unescape( document.cookie.substring( len, end ) );
}

declare function unescape(s: string): string



// WEBPACK FOOTER //
// ./src/analytics/cookie.ts